export const getReasons = (state) => state.reasons
export const getReasonsMeta = (state) => state.meta_data
export const getAllReasons = (state) => state.all_reasons


